var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97578 3.97578C4.2101 3.74147 4.59 3.74147 4.82431 3.97578L8.00005 7.15152L11.1758 3.97578C11.4101 3.74147 11.79 3.74147 12.0243 3.97578C12.2586 4.2101 12.2586 4.59 12.0243 4.82431L8.84858 8.00005L12.0243 11.1758C12.2586 11.4101 12.2586 11.79 12.0243 12.0243C11.79 12.2586 11.4101 12.2586 11.1758 12.0243L8.00005 8.84858L4.82431 12.0243C4.59 12.2586 4.2101 12.2586 3.97578 12.0243C3.74147 11.79 3.74147 11.4101 3.97578 11.1758L7.15152 8.00005L3.97578 4.82431C3.74147 4.59 3.74147 4.2101 3.97578 3.97578Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a495801f68669a91c13c6cd5629b58d8.svg";
export { ForwardRef as ReactComponent };